import React, { useState } from 'react';
import DatePicker from 'react-datepicker';

import Icon, { ICONS, COLORS } from './icon';

export enum DateTimePickerStyle {
	DATE = 'date',
	TIME = 'time',
}

interface DateTimePickerProps {
	dateOrTime: DateTimePickerStyle;
	startDate: Date;
	setStartDate: (date: Date) => void;
	showLabel?: boolean;
	showTodayButton?: boolean;
}

export default function DateTimePicker({
	dateOrTime,
	startDate,
	setStartDate,
	showLabel = true,
	showTodayButton = false,
}: DateTimePickerProps) {
	const [pickerFocused, setPickerFocused] = useState(false);

	return (
		<div
			className={`date-time-picker ${
				dateOrTime === DateTimePickerStyle.DATE ? 'date-picker' : 'time-picker'
			}`}
			onBlur={() => setPickerFocused(false)}
			data-testid="date-time-picker"
		>
			{showLabel && (
				<div className="date-time-picker__label bl-font-p2">
					{dateOrTime === DateTimePickerStyle.DATE ? 'Day' : 'Time'}
				</div>
			)}
			<div className="date-time-picker__selector">
				<div className="date-time-picker__icon">
					<Icon
						name={
							dateOrTime === DateTimePickerStyle.DATE
								? ICONS.CALENDAR
								: ICONS.CLOCK_ALT
						}
						color={
							pickerFocused
								? COLORS.TEXT_GRAY_200
								: COLORS.TEXT_GRAY_400
						}
						size={13.33}
					/>
				</div>
				{dateOrTime === DateTimePickerStyle.DATE ? (
					<DatePicker
						selected={startDate}
						onChange={(date) => {
							setStartDate(date instanceof Date ? date : startDate);
							setPickerFocused(false);
						}}
						dateFormat="MMM d yyyy"
						onFocus={() => setPickerFocused(true)}
						onBlur={() => setPickerFocused(false)}
						{...(showTodayButton && { todayButton: 'Today' })}
					/>
				) : (
					<DatePicker
						selected={startDate}
						onChange={(time) => {
							setStartDate(time instanceof Date ? time : startDate);
							setPickerFocused(false);
						}}
						dateFormat="h:mm aa"
						showTimeSelect
						showTimeSelectOnly
						timeIntervals={5}
						onFocus={() => setPickerFocused(true)}
						onBlur={() => setPickerFocused(false)}
					/>
				)}
			</div>
		</div>
	);
}
